/**
 * Indica si el estilo de barrera admite "barrier hit" intradía (American, Intraday).
 * Las europeas se observan al vencimiento: en detalle de producto el valor mostrado es NO.
 */
export function barrierStyleSupportsBarrierHit(barrierStyleName: string | null | undefined): boolean {
  const n = (barrierStyleName ?? '').trim().toUpperCase();
  if (!n) return false;
  return n.includes('AMERICAN') || n.includes('INTRADAY');
}

/**
 * American/Intraday: YES si el hit quedó en ProductCheck (permanente) o el worst-of está en/debajo del barrier.
 */
export function isAmericanBarrierHit(
  barrierStyleName: string | null | undefined,
  barrierHitRecorded: boolean | undefined,
  worstBarrierDistance: number | null | undefined,
): boolean {
  if (!barrierStyleSupportsBarrierHit(barrierStyleName)) {
    return false;
  }
  if (barrierHitRecorded === true) {
    return true;
  }
  return worstBarrierDistance != null && worstBarrierDistance <= 0;
}
